import Vue from 'vue'

import ModalInstance from './ModalInstance'

const ModalComponent = new Vue(ModalInstance).$mount('#modal')

export default ModalComponent
